import script from "./MediaGalleryEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaGalleryEdit.vue?vue&type=script&setup=true&lang=js"

import "./MediaGalleryEdit.vue?vue&type=style&index=0&id=07efdf18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07efdf18"]])

export default __exports__